#sign_code {
  --rds-form-elements-input-error-margin-block-start: 3px;
  white-space: nowrap;
}

#sign_code .rds-input--state-has-errors {
  margin-bottom: 0;
}

@media (min-width: 576px) {
  .submit-button-div {
    padding-top: 22px;
  }
}
